<div class="checklist-container">
    <!-- LEFT COLUMN: SIDEBAR LISTS -->
    <aside class="sidebar-lists">
        <div class="tab-header-actions search-mode">
            <!-- Angular Material Search Input (Identiek aan Notes) -->
            <mat-form-field appearance="outline" class="compact-form-field search-field">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput #searchInput placeholder="Search checklists..." (input)="onSearch(searchInput.value)"
                    (keyup.escape)="clearSearch(searchInput)">

                <button matSuffix mat-icon-button [style.visibility]="searchInput.value ? 'visible' : 'hidden'"
                    (click)="clearSearch(searchInput)">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <!-- Groene actieknop op exact dezelfde 40px grid-positie -->
            <button mat-icon-button (click)="createList()" matTooltip="Create List" class="add-folder-btn">
                <mat-icon>playlist_add</mat-icon>
            </button>
        </div>

        <!-- TREE WRAPPER -->
        <div class="tree-wrapper">
            <div class="lists-tree">
                <!-- Category 1: Calendars -->
                <div class="category-group" *ngIf="listsWithCalendar.length > 0">
                    <div class="category-header">
                        <span class="category-title">CALENDARS</span>
                    </div>
                    <div class="category-content">
                        <div *ngFor="let list of listsWithCalendar" (click)="selectList(list)" class="mat-tree-node"
                            [class.is-active]="selectedList?.id === list.id">
                            <span class="calendar-list-icon-png"></span>
                            <span class="node-text">{{ list.description }}</span>

                            <div class="node-actions">
                                <button mat-icon-button class="btn-node-edit" (click)="editList(list, $event)"
                                    matTooltip="Edit list">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button class="btn-node-edit" (click)="deleteList(list)"
                                    matTooltip="Delete item">
                                    <mat-icon>delete_outline</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Category 2: Standalone -->
                <div class="category-group" *ngIf="standaloneLists.length>0">
                    <div class="category-header">
                        <span class="category-title">STANDALONE LISTS</span>
                    </div>
                    <div class="category-content">
                        <div *ngFor="let list of standaloneLists" (click)="selectList(list)" class="mat-tree-node"
                            [class.is-active]="selectedList?.id === list.id">
                            <!--mat-icon class="node-icon">format_list_bulleted</mat-icon-->
                            <span *ngIf="list.isShared" class="shared-list-icon-png"></span>
                            <span *ngIf="!list.isShared" class="list-icon-png"></span>
                            <span class="node-text">{{ list.description }}</span>

                            <div class="node-actions">
                                <button mat-icon-button class="btn-node-edit" (click)="editList(list, $event)"
                                    matTooltip="Edit list">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button class="btn-node-edit" (click)="deleteList(list)"
                                    matTooltip="Delete item">
                                    <mat-icon>delete_outline</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Category 3: Shared -->
                <div class="category-group" *ngIf="sharedLists.length > 0 ">
                    <div class="category-header">
                        <span class="category-title">SHARED WITH ME</span>
                    </div>
                    <div class="category-content">
                        <div *ngFor="let list of sharedLists" (click)="selectList(list)" class="mat-tree-node"
                            [class.is-active]="selectedList?.id === list.id">
                            <!--mat-icon class="node-icon">format_list_bulleted</mat-icon-->
                            <span class="list-icon-png"></span>
                            <span class="node-text">{{ list.description }}</span>

                            <div class="node-actions">
                                <button mat-icon-button class="btn-node-edit" (click)="deleteList(list)"
                                    matTooltip="Delete item">
                                    <mat-icon>delete_outline</mat-icon>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="no-results"
                    *ngIf="searchTerm && listsWithCalendar.length === 0 && standaloneLists.length === 0">
                    <mat-icon>search_off</mat-icon>
                    <span>No checklists found matching "{{ searchTerm }}"</span>
                </div>
            </div>
        </div>
    </aside>



    <!-- RIGHT COLUMN: ACTIVE CHECKLIST VIEW -->
    <main class="active-checklist-view" *ngIf="selectedList; else noSelection">
        <header class="list-view-header">
            <div class="header-main">
                <h2>{{ selectedList.description }}</h2>
                <span class="calendar-tag" *ngIf="selectedList.calendarId > -1">
                    <mat-icon>calendar_today</mat-icon> {{ selectedList.calendar }}
                </span>

                <span class="fill-empty-space"></span>

                <!-- Compacte Sort Knop + Menu -->
                <button mat-icon-button [matMenuTriggerFor]="sortMenu" matTooltip="Sort items" class="btn-sort">
                    <mat-icon>sort</mat-icon>
                </button>

                <mat-menu #sortMenu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="setSortBy('position')">
                        <mat-icon [color]="sortBy === 'position' ? 'primary' : ''">
                            {{ sortBy === 'position' ? 'radio_button_checked' : 'radio_button_unchecked' }}
                        </mat-icon>
                        <span>Custom order (Drag & Drop)</span>
                    </button>
                    <button mat-menu-item (click)="setSortBy('alphabetical')">
                        <mat-icon [color]="sortBy === 'alphabetical' ? 'primary' : ''">
                            {{ sortBy === 'alphabetical' ? 'radio_button_checked' : 'radio_button_unchecked' }}
                        </mat-icon>
                        <span>Alphabetical (A-Z)</span>
                    </button>
                </mat-menu>
            </div>

            <div class="progress-container">
                <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="completionPercentage"></div>
                </div>
                <span class="progress-text">
                    {{ completedItems.length }} of {{ listItems.length }} completed ({{ completionPercentage }}%)
                </span>
            </div>
        </header>

        <!-- Sleek Material Input Box -->
        <div class="add-item-box">
            <mat-form-field appearance="outline" class="full-width compact-form-field">
                <button matPrefix mat-icon-button class="add-item-prefix-btn" (click)="addItem()"
                    [disabled]="!newItemDescription.trim()" matTooltip="Add item">
                    <mat-icon>add</mat-icon>
                </button>
                <input matInput [(ngModel)]="newItemDescription" (keyup.enter)="addItem()"
                    placeholder="Add a new item and press Enter..." />
            </mat-form-field>
        </div>

        <!-- Items Container -->
        <div class="checklist-items">

            <!-- Active Items met CDK Drag & Drop -->
            <div cdkDropList [cdkDropListDisabled]="sortBy !== 'position'" (cdkDropListDropped)="onItemDrop($event)"
                class="drag-list-container">
                <div class="item-row" *ngFor="let item of sortedActiveItems" [class.editing]="editingItemId === item.id"
                    cdkDrag>
                    <!-- Drag handle (optioneel icoon om te slepen) -->
                    <mat-icon *ngIf="sortBy === 'position' && editingItemId !== item.id" cdkDragHandle
                        class="drag-handle" matTooltip="Drag to reorder">
                        drag_indicator
                    </mat-icon>

                    <!-- WEERGAVE MODUS -->
                    <ng-container *ngIf="editingItemId !== item.id">
                        <mat-checkbox [checked]="item.checked" (change)="toggleItemStatus(item)" color="primary">
                        </mat-checkbox>

                        <span class="item-text" [innerHTML]="formatDescription(item.description)"></span>

                        <div class="item-actions">
                            <button mat-icon-button class="btn-action btn-edit-item" (click)="startEdit(item)"
                                matTooltip="Edit item">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button class="btn-action btn-delete-item" (click)="deleteItem(item)"
                                matTooltip="Delete item">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </div>
                    </ng-container>

                    <!-- EDIT MODUS -->
                    <ng-container *ngIf="editingItemId === item.id">
                        <mat-form-field appearance="outline" class="edit-form-field compact-form-field">
                            <input matInput [(ngModel)]="editingText" (keyup.enter)="saveEdit(item)"
                                (keyup.escape)="cancelEdit()" #editInput autofocus />

                            <div matSuffix class="inline-edit-actions">
                                <button mat-icon-button class="btn-action btn-save" (click)="saveEdit(item)"
                                    matTooltip="Save">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button mat-icon-button class="btn-action btn-cancel" (click)="cancelEdit()"
                                    matTooltip="Cancel">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </mat-form-field>
                    </ng-container>

                </div>
            </div>

            <!-- Divider for completed items -->
            <div class="completed-divider" *ngIf="completedItems.length > 0">
                <span>Completed ({{ completedItems.length }})</span>
            </div>

            <!-- Completed Items -->
            <div class="item-row completed" *ngFor="let item of completedItems">
                <mat-checkbox [checked]="item.checked" (change)="toggleItemStatus(item)" color="primary">
                </mat-checkbox>

                <span class="item-text" [innerHTML]="formatDescription(item.description)"></span>

                <button mat-icon-button class="btn-action btn-delete-item" (click)="deleteItem(item)"
                    matTooltip="Delete item">
                    <mat-icon>delete_outline</mat-icon>
                </button>
            </div>
        </div>
    </main>

    <ng-template #noSelection>
        <main class="active-checklist-view empty-state">
            <p>Select a checklist from the sidebar or create a new one.</p>
        </main>
    </ng-template>
</div>